import { DismissIcon, StarsButton } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import { active, close, error as errorClassName } from './Error.scss';

interface Props {
  onClose: () => void;
  error?: string;
}

const Error: React.FC<Props> = ({ onClose, error }) => (
  <div className={classNames(errorClassName, { [active]: !!error })}>
    <p>{error}</p>
    <StarsButton
      variant="text"
      size="small"
      className={close}
      icon={<DismissIcon />}
      onClick={onClose}
    />
  </div>
);

export default Error;
